import { useContext } from "react";
import { CardHeader } from "reactstrap";
import { H4, P } from "../../../../AbstractElements";
import { attendance, overAllAverage } from "../../../../Constant";
import CourseDropdown from "../../../../Common/Component/CourseDropdown";
import courseContext from "../../../../Helper/Courses";

const TotalEarningCardHeader = ({ overallPercentage, selectedCourseId, setSelectedCourseId }) => {
  const { activeCourse } = useContext(courseContext);
  return (
    <CardHeader className="pb-0">
      <div className="d-flex justify-content-between align-items-center">
        <div className="flex-grow-1">
          <div className="d-flex justify-content-between align-items-center">
            <P attrPara={{ className: "square-after f-w-600 header-text-primary m-0" }} >
              {attendance}
              <i className="fa fa-circle"> </i>
            </P>
            {
              !!overallPercentage &&
              <CourseDropdown isDashboard={true} selectCourse={selectedCourseId} setSelectCourse={setSelectedCourseId} isUser={true} notAllCourses={true} />
            }
          </div>
          <div className="my-3">
            <H4>{overAllAverage}: {overallPercentage}%</H4>
          </div>
        </div>
      </div>
    </CardHeader>
  );
};

export default TotalEarningCardHeader;